/**
 * @fileoverview Named constants for chat logic (HTTP codes, time units, file limits, WebSocket codes).
 * @module logic/chat/chatConstants
 */

export const COMPANY_NOT_FOUND = "Empresa no encontrada";
export const HTTP_OK = 200;
export const HTTP_CREATED = 201;
export const MS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const MS_PER_MINUTE = MS_PER_SECOND * SECONDS_PER_MINUTE;
export const MS_PER_HOUR = MS_PER_MINUTE * MINUTES_PER_HOUR;
export const MS_PER_DAY = MS_PER_HOUR * HOURS_PER_DAY;
export const WS_CLOSE_NORMAL = 1000;
export const WS_CLOSE_GOING_AWAY = 1001;
export const FILE_MAX_SIZE_MB = 10;
export const BYTES_PER_KB = 1024;
export const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;
export const FILE_MAX_SIZE_BYTES = FILE_MAX_SIZE_MB * BYTES_PER_MB;
export const SCROLL_INTO_VIEW_DELAY_MS = 100;
export const YESTERDAY_MAX_DAYS = 2;
export const SINGLE_HOUR_AGO_THRESHOLD = 2;
export const TIMESTAMP_ONE_MINUTE_THRESHOLD = 1;
export const TIMESTAMP_ONE_HOUR_THRESHOLD = 1;
export const FILE_SIZE_ZERO_BYTES = 0;
export const FILE_SIZE_DECIMAL_PLACES = 2;
